import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useStockEntryModel } from "../stockEntryModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { descTotal } = useStockEntryModel();
    const desc: IDescription[] = [
        {
            label: Locale["Stock-in Qty"],// "入库数量",
            value: descTotal.InTotal,
            color: DescriptionColorEnum.red
        },
        {
            label: Locale["Stock-in Doc Number"],//"入库单数",
            value: descTotal.totalNum,
            color: DescriptionColorEnum.red
        }
    ]

    return (
        <YhBox title={<></>} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}